import axios from "axios";

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

// CREATE SUBJECTIVE WELLBEING ASSESSMENT
export const submitSubjectiveWellbeingAssessment =
  async (assessmentData) => {

    try {

      const response = await axios.post(
        `${API_BASE_URL}/subjective-wellbeing`,
        assessmentData
      );

      return response.data;

    } catch (error) {

      console.error(
        "Error submitting subjective wellbeing assessment:",
        error
      );

      return null;
    }
};

// GET SUBJECTIVE WELLBEING HISTORY
export const fetchSubjectiveWellbeingHistory =
  async (userId) => {

    try {

      const response = await axios.get(
        `${API_BASE_URL}/subjective-wellbeing/${userId}`
      );

      return response.data;

    } catch (error) {

      console.error(
        "Error fetching subjective wellbeing history:",
        error
      );

      return null;
    }
};